<template>
    <v-layout :class="{ 'fill-height': !loaded }">
        <v-container
                fluid
                fill-height
                justify-center
                v-if="!loaded && !errorLoading"
        >
            <v-progress-circular :size="32" :width="3" color="#2ED1DF" indeterminate></v-progress-circular>
        </v-container>
        <slot name="error" v-if="errorLoading" class="error">
            <component :is="errorComponent" :error="errorResponse"></component>
        </slot>
        <slot v-if="loaded"></slot>
    </v-layout>
</template>

<script>
  import DefaultFadeLoaderError from '@/components/base/DefaultFadeLoaderError'

  export default {
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      loaded: {
        type: Boolean,
        default: true
      },
      errorLoading: {
        type: Boolean,
        default: false
      },
      errorResponse: {},
      errorComponent: {
        default: () => DefaultFadeLoaderError
      }
    }
  }
</script>

<style scoped>

</style>
